import { UIData, useUIStore } from '../../../hooks/stores/uiStore';
import { Dialog } from '../../common/Dialog';
import { ConnectModal } from './ConnectModal';
import { FeedbackModal } from './FeedbackModal';
import { VersionHistoryModal } from './VersionHistoryModal';

export const Modals = () => {
  const [UIData] = useUIStore<UIData>({ selector: ['isDialogOpen', 'dialogData'] });

  return (
    <>
      <VersionHistoryModal />
      <FeedbackModal />
      <ConnectModal />

      <Dialog isOpen={UIData.isDialogOpen} {...UIData.dialogData} />
    </>
  );
};
